import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6 py-24 pt-[120px]">
      <div className="max-w-md w-full text-center space-y-6 bg-slate-50 p-8 md:p-10 rounded-2xl border border-slate-100/80">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-50 text-slate-500 mx-auto">
          <i className="fa-regular fa-compass-slash text-3xl animate-pulse" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-extrabold tracking-tight text-primary font-display">404 - Page Not Found</h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            The page you are looking for does not exist or has been moved. Use the links below to find your way back.
          </p>
        </div>
        <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="py-3 px-6 rounded-xl bg-primary text-white font-semibold hover:bg-primary-light transition-all duration-200 text-sm shadow-sm"
          >
            Go to Homepage
          </Link>
          <Link
            to="/services"
            className="py-3 px-6 rounded-xl bg-slate-50 text-primary font-semibold hover:bg-slate-100 transition-all duration-200 text-sm border border-slate-100"
          >
            Our Solutions
          </Link>
        </div>
      </div>
    </div>
  );
}
